// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Button":"review-button__Button__2ZnJx","Icon":"review-button__Icon__36m-x"};